import {useEffect, useState} from 'react';

import type {OutlookRecipient} from '../../EmailScreen/Content/EmailRecipients/useOutlookEmailRecipients';
import {readComposeMessageMetadata} from '../../outlookComposeItem';
import {
  type ComposeMessageMetadata,
  requestComposeMessageMetadataFromParent,
  subscribeToComposeMessageMetadata,
  whenSendDialogParentListenerReady,
} from '../../sendDialogParentMessages';

const emptyMetadata: ComposeMessageMetadata = {
  fromAddress: '',
  subject: '',
  recipients: [],
};

export const useComposeMessageMetadata = (): ComposeMessageMetadata & {
  ready: boolean;
} => {
  const [metadata, setMetadata] =
    useState<ComposeMessageMetadata>(emptyMetadata);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    return subscribeToComposeMessageMetadata((next) => {
      setMetadata(next);
      setReady(true);
    });
  }, []);

  useEffect(() => {
    const hasDialogParent =
      typeof (Office.context?.ui as {messageParent?: unknown} | undefined)
        ?.messageParent === 'function';
    const load = hasDialogParent
      ? whenSendDialogParentListenerReady().then(() =>
          requestComposeMessageMetadataFromParent()
        )
      : readComposeMessageMetadata();

    void load
      .then((next) => {
        setMetadata(next);
      })
      .catch(() => {})
      .finally(() => {
        setReady(true);
      });
  }, []);

  return {
    fromAddress: metadata.fromAddress,
    subject: metadata.subject,
    recipients: metadata.recipients as OutlookRecipient[],
    ready,
  };
};
